import { actionTextColor } from "../utils/themeContrast";
/* eslint-disable no-console */
import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MenuSideBar from "../newcomponents/MenuSideBar";
import MenuContainer from "../newcomponents/MenuContainer";
import Modal from "../newcomponents/optioncomponents/Modal";
import MenuModalItem from "../newcomponents/optioncomponents/MenuModalItem";
import { navigate } from "@reach/router";
import moment from 'moment';
import styled from "@emotion/styled";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { IoCartOutline, IoReceiptOutline, IoChevronUpOutline } from "react-icons/io5";
import { UserContext, ActionContext, ThemeContext, LanguageContext } from "../contexts/Context";
import axios from "axios";
import MenuTopBar from '../newcomponents/MenuTopBar';
import promo from '../newcomponents/customerComponents/Promotion';
import ReviewOrderModal from "../newcomponents/ReviewOrderModal";
import { lightTint, readableText } from "../utils/themeContrast";
import Header from "../newcomponents/Header";
import { filterMenuListByAvailability } from "../utils/menuAvailability";

// import menulist from "./Menulist";
// import checkoutrec from "./checkOutRec";
// import { customer } from './customer';
// import containerItems from './containerItems';
// import recDummy from "./dummyRec";
// let menuList = menulist;
// let checkOutRec = checkoutrec;
// let isForCheckout = false;
// let isLoad = true;


const DESKTOP_MENU_MAX_WIDTH = 1440;
const MENU_SCROLL_POSITION_KEY = "menuScrollPosition";

const Menu = ({ category, codeId }) => {
  //Context
  const { cart, otherUrls, isTakeAway, isMenuView, title, menus, theme, lanIndex, disSubCatAtSide, searchTxt, isSearch, isSearching, hasInitFlow, initFlowCheck,
    allowTAafterWH, startTime, endTime, token, addItemDirect, unlimitedScroll, isScrolling, hasCategoryScreen, haveToLogin, hasMember,
    catPos, itemLayout, isLanReverse, pm, recentItem, recentBought, company, tkType, additionalPickUpTime, smartRec, takeAwayInfo, isScrollDown, topCatType,
    currencySymbol, hidePrice, tax, displayNetAmount } = React.useContext(UserContext);

  let { menuList, checkOutRec, isForCheckout, customer, containerItems, isLoad } = React.useContext(UserContext);

  const { addToCart, removeFromCart, setIsSearch, setSearchTxt, setSearching, setScrollDown } = React.useContext(ActionContext);
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  //Hook
  const { height, width: viewportWidth } = useWindowDimensions();
  const width = Math.min(viewportWidth, DESKTOP_MENU_MAX_WIDTH);
  // Desktop always uses the side rail. Mobile follows the customer's saved layout.
  const responsiveCatPos = width >= 768 ? 0 : (Number(catPos) === 1 ? 1 : 0);
  const hasMobileSidebar = width < 768 && responsiveCatPos === 0;
  const responsiveSidebarWidth = width >= 768
    ? Math.round(width * 0.25)
    : (hasMobileSidebar
      ? Math.max(96, Math.min(112, Math.round(width * 0.27)))
      : 0);
  const isReadOnlyMenu = isMenuView === true || isMenuView === "true";

  //State
  const [lastPos, setLastPos] = useState(0);
  const [show, setShow] = useState(false);
  const [showBill, setShowBill] = useState(false);
  const [recShow, setRecShow] = useState(false);
  const [error, setError] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isSub, setIsSub] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [mnList, setMnList] = useState([]);
  const [selectedRecommended, setSelectedRecommended] = useState(null);
  const [isCheckout, setIsCheckout] = useState(false);
  const [catList, setCatList] = useState([]);
  const [subCatObj, setSubCatObj] = useState({});
  const [subCat, setSubCat] = useState([]);
  const [promos, setPromos] = useState({});
  const [isMenuLoad, setLoad] = useState(false);
  const [hasCheck, setCheck] = useState(false);
  const [menuRecommendation, setMenuRecommendation] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [hasMobileScrolled, setHasMobileScrolled] = useState(false);
  const responsiveHeaderHeight = width >= 768 ? 60 : (hasMobileScrolled ? 34 : 72);
  const hasMobileScrollIntent = useRef(false);
  const hasRestoredScroll = useRef(false);
  //Ref to hold selection
  const menuSelectionFormRef = useRef(null);
  const getAvailabilityCheckTime = () => takeAwayInfo && takeAwayInfo.scheduleTime ? takeAwayInfo.scheduleTime : 0;

  useEffect(() => {
    const root = document.getElementById("root");
    if (!root) return undefined;
    const previousBackground = root.style.getPropertyValue("--menu-page-background");
    root.classList.add("menu-wide");
    root.style.setProperty("--menu-page-background", themeContext.backgroundColor || "#fff");

    return () => {
      root.classList.remove("menu-wide");
      if (previousBackground) root.style.setProperty("--menu-page-background", previousBackground);
      else root.style.removeProperty("--menu-page-background");
    };
  }, [themeContext.backgroundColor]);

  useEffect(() => {
    const menuScroll = document.getElementById("menu_scroll");
    if (!menuScroll) return undefined;

    let previousScrollTop = Math.max(0, menuScroll.scrollTop);
    let directionDistance = 0;
    const handleMenuScroll = () => {
      const scrollTop = Math.max(0, menuScroll.scrollTop);
      const delta = scrollTop - previousScrollTop;
      previousScrollTop = scrollTop;
      setShowScrollTop(menuScroll.scrollTop > 320);
      if (menuScroll.scrollTop <= 12) {
        hasMobileScrollIntent.current = false;
        setHasMobileScrolled(false);
        directionDistance = 0;
      } else if (width < 768 && hasMobileScrollIntent.current) {
        // Ignore tiny scroll changes; expand on upward movement anywhere in the menu.
        directionDistance = Math.sign(delta) === Math.sign(directionDistance) ? directionDistance + delta : delta;
        if (Math.abs(directionDistance) >= 8) {
          setHasMobileScrolled(directionDistance > 0);
          directionDistance = 0;
        }
      } else if (width >= 768) {
        setHasMobileScrolled(false);
      }
      sessionStorage.setItem(MENU_SCROLL_POSITION_KEY, `${menuScroll.scrollTop}`);
    };
    const handleMobileScrollIntent = () => {
      if (width < 768) hasMobileScrollIntent.current = true;
    };

    setShowScrollTop(menuScroll.scrollTop > 320);
    menuScroll.addEventListener("scroll", handleMenuScroll, { passive: true });
    menuScroll.addEventListener("wheel", handleMobileScrollIntent, { passive: true });
    menuScroll.addEventListener("touchmove", handleMobileScrollIntent, { passive: true });

    return () => {
      menuScroll.removeEventListener("scroll", handleMenuScroll);
      menuScroll.removeEventListener("wheel", handleMobileScrollIntent);
      menuScroll.removeEventListener("touchmove", handleMobileScrollIntent);
    };
  }, [width]);

  useLayoutEffect(() => {
    if (!isMenuLoad || mnList.length === 0 || hasRestoredScroll.current) return undefined;

    const menuScroll = document.getElementById("menu_scroll");
    const savedPosition = Number(sessionStorage.getItem(MENU_SCROLL_POSITION_KEY));
    if (!menuScroll) return undefined;
    if (!Number.isFinite(savedPosition) || savedPosition <= 0) {
      if (responsiveCatPos === 0 && !category && !codeId) {
        setSelectedCategory(mnList[0]);
        menuScroll.scrollTo({ top: 0, behavior: "instant" });
        setScrollDown(false);
      }
      hasRestoredScroll.current = true;
      return undefined;
    }

    menuScroll.scrollTo({ top: savedPosition, behavior: "instant" });
    setShowScrollTop(savedPosition > 320);
    setHasMobileScrolled(false);
    hasRestoredScroll.current = true;

  }, [isMenuLoad, mnList.length, width]);

  const scrollMenuToTop = () => {
    const menuScroll = document.getElementById("menu_scroll");
    if (!menuScroll) return;

    menuScroll.scrollTo({ top: 0, behavior: "smooth" });
    setScrollDown(false);
  };

  useEffect(() => {
    let order = JSON.parse(localStorage.getItem("order"));
    if (order) {
      addToCart(order);
    }
  }, [addToCart]);

  useEffect(() => {
    if (!isLoad) return;
    if (!isMenuLoad) return;
    if (hasCheck) return;
    setCheck(true);
    if (mnList.length == 0) {
      window.location.replace(company && company.url ? company.url : "https://google.com");
    }

  }, [mnList, isLoad]);

  //filter menu
  useEffect(() => {
    // if(hasInitFlow && !initFlowCheck){
    //   navigate("/initflow");
    //   return;
    // }
    if (hasMember === true && haveToLogin === true && (customer == "" || customer == null)) {
      window.location.replace(company && company.url ? company.url : "https://google.com");
      return;
    }
    let checkinTime = localStorage.getItem("checkIn");
    if (checkinTime) {
      let diff = (new Date().getTime() - checkinTime) / 1000 / 60 / 60;

      if (diff > 1) {
        window.location.replace(company && company.url ? company.url : "https://google.com");
        return;
      }

    }




    if (isTakeAway && !allowTAafterWH) {
      let stime = moment(startTime);
      let etime = moment(endTime);
      let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let day = new Date().getDay();
      let st = moment().set("hour", stime.get("hour")).set("minute", stime.get("minute"));
      let et = moment().set("hour", etime.get("hour")).set("minute", etime.get("minute"));
      if (stime.get("hour") < etime.get('hour')) {
        et = et.add(24, "hour");
      }
      if (moment().isBefore(st) || moment().isAfter(et)) {
        //need to check if has other time
        let isMatch = false;
        for (let pk of additionalPickUpTime) {
          if (pk.weekDays && pk.weekDays.indexOf(tdyTxt[day]) > -1) {
            stime = moment(pk.startTime);
            etime = moment(pk.endTime);
            st = moment().set("hour", stime.get("hour")).set("minute", stime.get("minute"));
            et = moment().set("hour", etime.get("hour")).set("minute", etime.get("minute"));

            if (moment().isAfter(st) && moment().isBefore(et)) {
              isMatch = true;
              break;
            }
          }
        }
        if (!isMatch)
          window.location.replace(company && company.url ? company.url : "https://google.com");
      }
    }
  }, [isTakeAway]);

  useEffect(() => {
    if (isSearch) {
      setSelectedCategory(null);
      setSelectedMenu(null);
      setIsSearch(false);
    }
  }, [isSearch])

  const isSelected = (subCat) => {
    for (let cat of subCat) {
      if (selectedCategory != null && cat.category == selectedCategory.category) return true;
    }
    return false;
  };



  useEffect(() => {
    if (!isLoad) return;
    // if (isMenuLoad) return;

    if (title && menus && menus.length > 1) {
      menuList = menuList.filter((mn) => {
        return mn.title == title;
      })
    }
    let mnList = filterMenuListByAvailability(JSON.parse(JSON.stringify(menuList)), getAvailabilityCheckTime());
    if (searchTxt) {
      mnList = mnList.filter(mn => {
        let isMatch = false;
        if (mn.category.toLocaleLowerCase().includes(searchTxt.toLocaleLowerCase())) {
          isMatch = true;
        } else {
          mn.type = mn.type.filter((it) => {
            if (!it.isCategory && it.title && it.title.toLocaleLowerCase().includes(searchTxt.toLocaleLowerCase())) {
              isMatch = true;
              it.size = 0;
              return true;
            } else if (it.isCategory) {
              it.type = it.type.filter(i => {
                if (i.title && i.title.toLocaleLowerCase().includes(searchTxt.toLocaleLowerCase())) {
                  isMatch = true;
                  it.size = 0;
                  return true;
                } else {
                  return false;
                }
              });
              return it.type.length > 0;
            } else {
              return false;
            }
          });
        }

        return isMatch;
      });

    }

    if (selectedCategory != null && selectedMenu == null) {
      //need to update the selected Category
      for (let cat of mnList) {
        if (cat.isCategory) {
          for (let subCat of cat.type) {
            if (subCat.category == selectedCategory.category) {
              setSelectedCategory(subCat);
              break;
            }
          }
        } else if (cat.category == selectedCategory.category) {
          setSelectedCategory(cat);
          break;
        }
      }
    }
    setMnList(mnList);
  }, [searchTxt, title, menus, takeAwayInfo]);

  useEffect(() => {
    if (!isLoad) return;
    if (isMenuLoad) return;

    if (title && menus && menus.length > 1) {
      menuList = menuList.filter((mn) => {
        return mn.title == title;
      })
    }
    let mnList = filterMenuListByAvailability(JSON.parse(JSON.stringify(menuList)), getAvailabilityCheckTime());

    if (selectedCategory != null && selectedMenu == null) {
      //need to update the selected Category
      for (let cat of mnList) {
        if (cat.isCategory) {
          for (let subCat of cat.type) {
            if (subCat.category == selectedCategory.category) {
              setSelectedCategory(subCat);
              break;
            }
          }
        } else if (cat.category == selectedCategory.category) {
          setSelectedCategory(cat);
          break;
        }
      }
    }
    setLoad(true);
    setMnList(mnList);
  }, [isLoad, menuList, title, menus, takeAwayInfo]);

  useEffect(() => {
    if (!isLoad || !isMenuLoad || !token) return;

    let cancelled = false;
    setMenuRecommendation(null);
    axios.post("/v2/api/selforder/menu/recommendation", { cart: [] }, {
      headers: { Authorization: "Bearer " + token }
    })
      .then((response) => {
        if (cancelled) return;
        const recommendation = response.data;
        if (recommendation && Array.isArray(recommendation.options) && recommendation.options.length > 0) {
          setMenuRecommendation(recommendation);
        }
      })
      .catch((error) => {

      });

    return () => {
      cancelled = true;
    };
  }, [isLoad, isMenuLoad, token, title]);


  useEffect(() => {
    let catList = [], subCatObj = {}, subCat = [];
    mnList.forEach((mn) => {
      subCat = [];
      catList.push(mn);
      if (mn.type) {
        mn.type.forEach(ci => {
          if (ci.isCategory) {
            ci.isSub = true;
            subCat.push(ci);
            if (!subCatObj[mn.category]) subCatObj[mn.category] = [];
            subCatObj[mn.category].push(ci);
          }
        });
      }
      if (disSubCatAtSide && selectedCategory != null &&
        (selectedCategory.category == mn.category || isSelected(subCat)) &&
        responsiveCatPos === 0) {
        catList = catList.concat(subCat);
      }
    });
    setCatList(catList);
    setSubCatObj(subCatObj);
    setSubCat(subCat);
  }, [mnList, selectedCategory, responsiveCatPos])

  useEffect(() => {
    if (selectedCategory == null) return;

    if (subCatObj[selectedCategory.category]) {
      setIsSub(true);
      return;
    };
    for (let key in subCatObj) {
      for (let sc of subCatObj[key]) {
        if (sc.category == selectedCategory.category) {
          setIsSub(true);
          return;
        }
      }
    }
    setIsSub(false);
  }, [selectedCategory]);

  const onBackChange = (e) => {

    setSelectedMenu(null);
    if ((!category || category == null)) {
      window.history.pushState(null, null, "/menu");
    } else if (window.location && window.location.pathname.includes("/menu/menu")) {
      setSelectedMenu(null);
    } else {
      window.history.pushState(null, null, "/menu");
    }
  }

  useEffect(() => {
    window.addEventListener('popstate', onBackChange, false);
    return () => {
      window.removeEventListener('popstate', onBackChange);
    }
  }, []);

  useEffect(() => {
    if (!token || !title) return;
    //check if qrcode is buffet and is expired or not
    axios.post("/v2/api/selfOrder/valid", { title: title }, { headers: { Authorization: "Bearer " + token } })
      // axios.post("https://selforder2.chachingfnb.com/v2/api/selfOrder/valid", { title: title }, { headers: { Authorization: "Bearer " + token } })
      .then((res) => {
        if (res.status == 400) {
          window.location.replace(company && company.url ? company.url : "https://google.com");
        }
      })
      .catch((e) => {
        window.location.replace(company && company.url ? company.url : "https://google.com");
      });
  }, [token, title]);

  useEffect(() => {
    if (unlimitedScroll) return;

    if (codeId != null && codeId) {
      filterMenuListByAvailability(menuList, getAvailabilityCheckTime()).forEach(mn => {
        mn.type.forEach(m => {
          if (!m.isCategory && m.codeId == codeId) {
            setSelectedMenu(m);
            setSelectedCategory(mn);
          } else if (m.isCategory) {
            m.type.forEach(c => {
              if (c.codeId == codeId) {
                setSelectedMenu(c);
                setSelectedCategory(m);
              }
            })
          }
        })
      });
    } else if (category != null && category) {
      filterMenuListByAvailability(menuList, getAvailabilityCheckTime()).forEach(mn => {
        let mCat = mn.category;
        mCat = mCat.replaceAll("/", "").replaceAll("%", "");

        if (mCat == category) {
          setSelectedMenu(null);
          setSelectedCategory(mn);
        }
        mn.type.forEach((m) => {
          mCat = m.category;
          if (mCat) {
            mCat = mCat.replaceAll("/", "").replaceAll("%", "");
            if (m.isCategory && mCat == category) {
              setSelectedMenu(null);
              setSelectedCategory(m);
            }
          }
        })
      })
    } else if (codeId == null && category == null) {
      setSelectedMenu(null);
    }
  }, [codeId, category, takeAwayInfo]);

  useLayoutEffect(() => {
    if (selectedMenu) {
      if (selectedMenu.recommendedArray.length > 0) {
        setSelectedRecommended(JSON.parse(JSON.stringify(selectedMenu.recommendedArray)));
      }
      //no need to go to item detail, add to cart straightaway
      if (addItemDirect && (!selectedMenu.optionArray || selectedMenu.optionArray.length == 0)) {

        menuSelectionFormRef.current = JSON.parse(JSON.stringify(selectedMenu));

        addNewItemToCart(selectedMenu);
        setSelectedMenu(null);
      }
    }
  }, [selectedMenu]);


  const addRecentItem = () => {
    let recentIt = JSON.parse(JSON.stringify(recentItem));
    for (let it of recentIt) {
      it.active = true;
      it.qty = 1;
    }
    addRecItemToCart(recentIt);
  }

  //Method
  const addRecItemToCart = (items) => {
    let hasCkItem = false;
    items.forEach((it) => {
      if (it.active) {
        hasCkItem = true;
      }
    });
    if (!hasCkItem) {
      setRecShow(false);
      return;
    }
    let push = true;
    let combine = false;
    let newCart = JSON.parse(JSON.stringify(cart));

    const pushOrCombine = (push, item, newItem) => {
      if (push === true) {
        newCart.push(newItem);
      } else {
        item.qty = item.qty + newItem.qty;
        item.remark = item.remark.concat(newItem.remark);
      }
      localStorage.setItem("order", JSON.stringify(newCart));
    };

    items.forEach((it, index) => {
      if (it.active) {
        let newItem = JSON.parse(JSON.stringify(it));
        newItem.recommendId = "MREC";
        newItem.remark = "";
        let cartIndex;
        let optionArrayIndex;
        let optionsIndex;

        let metConflict = false;

        if (newCart.length > 0) {
          for (cartIndex = 0; cartIndex < newCart.length; cartIndex++) {
            let item = newCart[cartIndex];

            if (item.title === newItem.title) {
              for (
                optionArrayIndex = 0;
                optionArrayIndex < item.optionArray.length;
                optionArrayIndex++
              ) {
                let optionArray = item.optionArray[optionArrayIndex];
                for (
                  optionsIndex = 0;
                  optionsIndex < optionArray.options.length;
                  optionsIndex++
                ) {
                  let optionsSelection = optionArray.options[optionsIndex];
                  if (
                    optionsSelection.active !==
                    newItem.optionArray[optionArrayIndex].options[optionsIndex].active
                  ) {

                    metConflict = true;
                    break;
                  }
                }
                if (newItem.remark != item.remark) {
                 
                  pushOrCombine(push, "", newItem);
                  return;
                } else if (metConflict === true) {
                  metConflict = false;
                  if (cartIndex === newCart.length - 1) {
                   
                    pushOrCombine(push, "", newItem);
                    return; //return;
                  }
                  break;
                } else if (metConflict === false) {
                  if (optionArrayIndex === item.optionArray.length - 1) {
                   
                    pushOrCombine(combine, item, newItem);
                    return; //return;
                  }
                }
              }

              if (newItem.remark != item.remark) {
              
                pushOrCombine(true, "", newItem);
                return;
              } else if (item.optionArray.length === 0) {
                
                pushOrCombine(combine, item, newItem);
                return; //return;
              }
            }
            if (cartIndex === newCart.length - 1) {
              
              pushOrCombine(push, "", newItem);
              return; //return;
            }
          }
        } else {
         
          pushOrCombine(push, "", newItem);
          return; //return;
        }
      }
    });

    //remove item that is empty
    let i = 0;
    while (i < newCart.length) {
      if (newCart[i].qty == 0) {
        newCart.splice(i);
      } else {
        i++;
      }
    }

    //apply promotion

    if (pm && pm.length > 0) {
      newCart = promo.clearPromotion(newCart);
      newCart = promo.applyPromotion(pm, newCart);
    }

    newCart = promo.removeContainer(newCart);
    newCart = promo.applyContainer(newCart, containerItems, isTakeAway && tkType != 1);

    localStorage.setItem("order", JSON.stringify(newCart));

    addToCart(newCart);
    setSelectedRecommended(null);
    setRecShow(false);
  }


  const isItemMatch = (item, newItem) => {
    if (item.codeId === newItem.codeId) {
      if (newItem.remark != item.remark) {
        return { isMatch: false, item };
      } else if (item.active != newItem.active) {
        return { isMatch: false, item };
      } else if (!item.optionArray || item.optionArray.length === 0) {
        return { isMatch: true, item };
      }
      let isMatch = true;
      for (let i = 0; i < item.optionArray.length; i++) {
        let optionArray = item.optionArray[i];

        for (let j = 0; j < optionArray.options.length; j++) {
          let optionsSelection = optionArray.options[j];
          if (optionsSelection.active !== newItem.optionArray[i].options[j].active) {

            isMatch = false;
            break;
          }
          if ((optionsSelection.qty && !newItem.optionArray[i].options[j].qty) ||
            (!optionsSelection.qty && newItem.optionArray[i].options[j].qty)
          ) {
            isMatch = false;
            break;
          }
          if (optionsSelection.qty && newItem.optionArray[i].options[j].qty &&
            optionsSelection.qty != newItem.optionArray[i].options[j].qty
          ) {
            isMatch = false;
            break;
          }
        }
        if (!isMatch) break;
      }
      if (!isMatch) return { isMatch: false, item };
      if (isMatch) return { isMatch: true, item };
    }
    return { isMatch: false, item: {} };

  };

  const addNewItemToCart = (newItemSelection, isRecommended, mods) => {
    let push = true;
    let combine = false;
    let newItem;

    if (checkIfSelected(isRecommended, mods)) {
      //return back to home
      if (selectedCategory != null) {
        let cat = selectedCategory.category;
        if (cat != null) {
          cat = cat.replaceAll("/", "").replaceAll("%", "");
          if (!unlimitedScroll)
            navigate('/menu/menu/' + cat);
          else
            navigate('/menu');
        }
      }
      if (isRecommended) {
        newItem = JSON.parse(JSON.stringify(newItemSelection));
        newItem.qty = mods.qty;
        newItem.remark = mods.remark;
      } else {
        newItem = JSON.parse(JSON.stringify(selectedMenu));
        newItem.price = newItemSelection.price;
        newItem.optionArray = newItemSelection.optionArray;

        //update quantity and remark
        newItem.qty = newItemSelection.qty;
        newItem.remark = newItemSelection.remark ? newItemSelection.remark : "";
        newItem.isTakeAway = Boolean(newItemSelection.isTakeAway);
      }

      let newCart = JSON.parse(JSON.stringify(cart));

      const pushOrCombine = (push, item) => {
        if (push === true) {
          newCart.push(newItem);
        } else {
          item.qty = item.qty + newItem.qty;
          item.remark = item.remark.concat(newItem.remark);
        }


        if (pm && pm.length > 0) {
          newCart = promo.clearPromotion(newCart);
          newCart = promo.applyPromotion(pm, newCart);
        }

        newCart = promo.removeContainer(newCart);
        newCart = promo.applyContainer(newCart, containerItems, isTakeAway && tkType != 1);

        localStorage.setItem("order", JSON.stringify(newCart));
        addToCart(newCart);
        if (!isRecommended) {
          if (selectedRecommended && selectedMenu.hasRecommended === true) {
            setRecShow(true);
            setIsCheckout(false);
          }
          setSelectedMenu(null);
        } else {
          setSelectedRecommended(null);
          setRecShow(false);
        }
      };

      if (newItem.isSetMeal === true) {
        for (let item of newCart) {
          let isMatch;
          if (item.codeId === newItem.codeId) {
            if (newItem.remark != item.remark) {
              continue;
            }
            if (newItem.isTakeAway != item.isTakeAway) {
              continue;
            }
            isMatch = true;
            for (let i = 0; i < item.optionArray.length; i++) {
              for (let j = 0; j < item.optionArray[i].options.length; j++) {
                if (!isItemMatch(item.optionArray[i].options[j], newItem.optionArray[i].options[j]).isMatch) {
                  isMatch = false;
                  break;
                }
              }
              if (!isMatch) break;
            }
            if (!isMatch) continue;
            if (isMatch) {
              pushOrCombine(false, item);
              return;
            }
          }


        }
        //isSetMeal different rules
        pushOrCombine(push);
      } else {
        //Combine quantity if order has same options
        let cartIndex;
        let optionArrayIndex;
        let optionsIndex;

        let metConflict = false;

        if (newCart.length > 0) {
          for (cartIndex = 0; cartIndex < newCart.length; cartIndex++) {
            let item = newCart[cartIndex];

            if (item.codeId === newItem.codeId) {
              for (optionArrayIndex = 0; optionArrayIndex < item.optionArray.length; optionArrayIndex++) {
                let optionArray = item.optionArray[optionArrayIndex];
                for (optionsIndex = 0; optionsIndex < optionArray.options.length; optionsIndex++) {
                  let optionsSelection = optionArray.options[optionsIndex];
                  if (optionsSelection.active !== newItem.optionArray[optionArrayIndex].options[optionsIndex].active) {
                   
                    metConflict = true;
                    break;
                  }
                  if ((!optionsSelection.qty && newItem.optionArray[optionArrayIndex].options[optionsIndex].qty) ||
                    (optionsSelection.qty && !newItem.optionArray[optionArrayIndex].options[optionsIndex].qty)) {
                    metConflict = true;
                    break;
                  }
                  if (optionsSelection.qty && newItem.optionArray[optionArrayIndex].options[optionsIndex].qty &&
                    optionsSelection.qty != newItem.optionArray[optionArrayIndex].options[optionsIndex].qty
                  ) {
                    metConflict = true;
                    break;
                  }
                }

                if (newItem.remark != item.remark) {
                  pushOrCombine(true);
                  return;
                } else if (newItem.isTakeAway != item.isTakeAway) {
                  pushOrCombine(true);
                  return;
                } else if (metConflict === true) {
                 
                  metConflict = false;
                  if (cartIndex === newCart.length - 1) {
                  
                    pushOrCombine(push);
                    return; //return;
                  }
                  break;
                } else if (metConflict === false) {
                  if (optionArrayIndex === item.optionArray.length - 1) {
                   
                    pushOrCombine(combine, item);
                    return; //return;
                  }
                }
              }
              if (newItem.remark != item.remark) {
               
                pushOrCombine(true);
                return;
              } else if (newItem.isTakeAway != item.isTakeAway) {
                pushOrCombine(true);
                return;
              } else if (item.optionArray.length === 0) {
               
                pushOrCombine(combine, item);
                return; //return;
              }
            }
            if (cartIndex === newCart.length - 1) {
            
              pushOrCombine(push);
              return; //return;
            }
          }
        } else {
         
          pushOrCombine(push);
          return; //return;
        }
      }
    }
  };

  //Slightly bugged. //Untested, but logic should be sound.
  const countQty = () => {
    let qty = 0;
    cart.forEach((ct) => {
      qty += ct.qty;
    })
    return qty;
  }

  // Match item prices: include tax when displayNetAmount is on
  const cartDisplayAmount = () => {
    if (!displayNetAmount || !tax) return promo.subTotalAmount(cart);
    return cart.reduce((total, item) =>
      total + promo.subTotalAmount([item]) * (1 + Number(tax.taxMode == 0 ? tax.tax : item.tax || 0)), 0);
  }

  const checkIfSelected = (isRecommended, mods) => {
    const skipOption = ["No Dressing Please!", "No Crunches"];
    let errorMessages = [];
    let optionArray = isRecommended
      ? menuSelectionFormRef.current.recommendedArray
      : menuSelectionFormRef.current.optionArray;


    let alertSubject = isRecommended ? "Add-on: " : `${languageContext[lanIndex].setMeal}: `;
    let quantityCheck = isRecommended
      ? mods.qty
      : menuSelectionFormRef.current.qty;

    if (isRecommended === true) {
      let element = optionArray[0];
      if (element.optionActive === true && element.optionRequired && element.options.length > 0) {
        let foundActiveOptionArraySelection = element.options.find(
          (option) => option.active === true
        );

        if (!foundActiveOptionArraySelection) {
          errorMessages.push({
            errorElement: element.optionTitle,
            errorMessage: (
              <>
                <b style={{ color: "#CF000D" }}>
                  {alertSubject + ((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element.optionTitle : element.optionTitle2)}
                </b>{" "}
                <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
              </>
            ),
          });
        } else {
          foundActiveOptionArraySelection.optionArray.forEach((element2) => {
            if (element2.optionActive === true && element2.optionRequired) {
              let setMealDepthOptionFound = element2.options.find(
                (option) => option.active === true
              );
              if (!setMealDepthOptionFound) {
                errorMessages.push({
                  errorElement: element2.optionTitle,
                  errorMessage: (
                    <>
                      <b style={{ color: "#CF000D" }}>{(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element2.optionTitle : element2.optionTitle2}</b>
                      {" of "}
                      <b style={{ color: "#CF000D" }}>
                        {alertSubject + ((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element.optionTitle : element.optionTitle2)}
                      </b>{" "}
                      <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                    </>
                  ),
                });
              }
            }
          });
        }
      }
    } else if (menuSelectionFormRef.current.isSetMeal === true) {
     
      optionArray.forEach((element) => {
        if (element.optionActive === true && element.optionRequired && element.options.length > 0) {
          let selected = 0;
          let hasNoOption = false;
          element.options.forEach((option) => {
            if (option.active) {
              selected += (option.qty ? option.qty : 1);
              if (skipOption.indexOf(option.title) > -1) hasNoOption = true;
            }
          });

          let foundActiveOptionArraySelection = element.options.find((option) => option.active === true);

          if (!foundActiveOptionArraySelection || (element.isMultiple && selected < element.minQty && !hasNoOption)) {
            errorMessages.push({
              errorElement: element.optionTitle,
              errorMessage: (
                <>
                  <b style={{ color: "#CF000D" }}>
                    {alertSubject + ((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element.optionTitle : element.optionTitle2)}
                  </b>&nbsp;
                  <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                </>
              ),
            });
          } else {
            //nested Option
            foundActiveOptionArraySelection.optionArray &&
              foundActiveOptionArraySelection.optionArray.forEach((element2) => {
                if (element2.optionActive === true && element2.optionRequired) {
                  let selected2 = 0;
                  element2.options.forEach((option) => { if (option.active) selected2 += (option.qty ? option.qty : 1); });
                  let setMealDepthOptionFound = element2.options.find((option) => option.active === true);
                  if ((element2.isMultiple && selected2 < element2.minQty) || !setMealDepthOptionFound) {
                    errorMessages.push({
                      errorElement: element2.optionTitle,
                      errorMessage: (
                        <>
                          <b style={{ color: "#CF000D" }}>
                            {((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element2.optionTitle : element2.optionTitle2)}
                          </b>
                          {" of "}
                          <b style={{ color: "#CF000D" }}>
                            {alertSubject + ((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element.optionTitle : element.optionTitle2)}
                          </b>&nbsp;
                          <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                        </>
                      ),
                    });
                  }
                }
              });
          }
        } else if (element.optionActive === true && element.options.length > 0) {
          //even option is not compulsory, but nested may be compulsory
          let foundActiveOptionArraySelection = element.options.find((option) => option.active === true);
          foundActiveOptionArraySelection && foundActiveOptionArraySelection.optionArray &&
            foundActiveOptionArraySelection.optionArray.forEach((element2) => {
              if (element2.optionActive === true && element2.optionRequired) {
                let selected2 = 0;
                element2.options.forEach((option) => { if (option.active) selected2 += (option.qty ? option.qty : 1); });
                let setMealDepthOptionFound = element2.options.find((option) => option.active === true);
                if ((element2.isMultiple && selected2 < element2.minQty) || !setMealDepthOptionFound) {
                  errorMessages.push({
                    errorElement: element2.optionTitle,
                    errorMessage: (
                      <>
                        <b style={{ color: "#CF000D" }}>
                          {((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element2.optionTitle : element2.optionTitle2)}
                        </b>
                        {" of "}
                        <b style={{ color: "#CF000D" }}>
                          {alertSubject + ((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element.optionTitle : element.optionTitle2)}
                        </b>&nbsp;
                        <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                      </>
                    ),
                  });
                }
              }
            });
        }
      });
    } else {
      optionArray.forEach((element) => {
        if (element.optionActive === true && element.optionRequired && element.options.length > 0) {
          let checkActive = false;
          let selected = 0;
          let hasNoOption = false;
          element.options.forEach((option) => {
            if (option.active === true) {
              checkActive = true;
              if (skipOption.indexOf(option.title) > -1) hasNoOption = true;
              selected += (option.qty ? option.qty : 1);
            }
          });

          if ((checkActive === false && !element.isMultiple) || (element.isMultiple && selected < element.minQty && !hasNoOption)) {
            errorMessages.push({
              errorElement: element.optionTitle,
              errorMessage: (
                <>
                  <b style={{ color: "#CF000D" }}>{(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element.optionTitle : element.optionTitle2}</b>
                  &nbsp;
                  <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                </>
              ),
            });
          }
        }
      });
    }

    if (quantityCheck < 1) {
      errorMessages.push({
        errorElement: "Quantity",
        errorMessage: (
          <>
            <b style={{ color: "#CF000D" }}>Quantity</b> cannot be less than{" "}
            <b>1</b> please re-adjust.
          </>
        ),
      });
    }

    if (errorMessages.length > 0) {

      setError(errorMessages);
      setShow(true);
      return false;
    }
    return true;
  };

  const clickCheckout = () => {
    setIsSearch(false);
    setSearchTxt("");
    setSearching(false);
    if (isForCheckout) {
      setRecShow(true);
      setIsCheckout(true);
      setSelectedRecommended([JSON.parse(JSON.stringify(checkOutRec))]);
    } else {
      navigate('/checkout');
    }
  }

  if (typeof lanIndex === 'undefined') {
    return <></>
  }
  let shouldExpand = false;
  if (selectedMenu == null || (selectedMenu != null && selectedMenu.optionArray.length == 0 && addItemDirect)) {
    shouldExpand = true;
  }
  const mobileTakeawayOffset = 0;
  const effectiveScrollDown = isSearching || (width < 768 ? hasMobileScrolled : isScrollDown);
  const isScrollUp = !isScrollDown;
  return (
    <MenuLayout>
      {(recShow && (smartRec || (selectedRecommended && selectedRecommended != null))) &&
        <MenuModalItem
          show={recShow}
          setShow={setRecShow}
          isCheckout={isCheckout}
          smartRec={smartRec}
          recommendedArray={selectedRecommended}
          setRecommendedArray={setSelectedRecommended}
          menuSelectionFormRef={menuSelectionFormRef}
          addNewItemToCart={addRecItemToCart}

        />
      }
      {showBill && <ReviewOrderModal show={showBill} setShow={setShowBill} />}
      <Modal show={show} setShow={setShow} error={error} />
      {!isReadOnlyMenu && !(selectedMenu && (!addItemDirect || (addItemDirect && selectedMenu.optionArray.length > 0))) &&
        <CartButtonContainer themeContext={themeContext}>
          <BillButton type="button" themeContext={themeContext} onClick={() => setShowBill(true)}>
            <IoReceiptOutline size={18} aria-hidden="true" />
            <span>{lanIndex == 1 ? "账单" : "Bill"}</span>
          </BillButton>
          <CartButton type="button" themeContext={themeContext} onClick={clickCheckout} aria-label={languageContext[lanIndex].checkout}>
            <IoCartOutline size={20} aria-hidden="true" />
            <CartText>{lanIndex == 1 ? `本轮 ${countQty()} 件` : `${countQty()} in this round`}</CartText>
            {!hidePrice && <CartAmount>{currencySymbol}{Number(cartDisplayAmount()).toFixed(2)}</CartAmount>}
          </CartButton>
        </CartButtonContainer>
      }
      <Header
        hasBack={selectedMenu == null}
        wide
        showMobileCart={!isReadOnlyMenu}
        cartQuantity={countQty()}
        cartAmount={hidePrice ? null : cartDisplayAmount()}
        currencySymbol={currencySymbol}
        onCartClick={clickCheckout}
        mobileMenuHeader
        categorySearch
        mobileCollapsed={hasMobileScrolled}
      />
      {responsiveCatPos === 0 &&
        <MenuSideBar
          height={height}
          itemList={catList}
          otherUrls={otherUrls}
          category={category}
          selectedMenu={selectedMenu}
          unlimitedScroll={unlimitedScroll}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          setSelectedMenu={setSelectedMenu}
          setLastPos={setLastPos}
          sidebarWidth={responsiveSidebarWidth}
          headerHeight={responsiveHeaderHeight + mobileTakeawayOffset}
        />
      }
      {responsiveCatPos === 1 &&
        <MenuTopBar
          height={height}
          itemList={catList}
          subCatObj={subCatObj}
          otherUrls={otherUrls}
          category={category}
          width={width}
          selectedMenu={selectedMenu}
          unlimitedScroll={unlimitedScroll}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          setSelectedMenu={setSelectedMenu}
          setLastPos={setLastPos}
          addItemDirect={addItemDirect}
          shouldExpand={shouldExpand}
          isScrollDown={effectiveScrollDown}
          isScrollUp={isScrollUp}
          topCatType={topCatType}
          headerHeight={responsiveHeaderHeight}
          takeawayOffset={mobileTakeawayOffset}
        />
      }
      <MenuContainer
        width={width}
        height={height - (responsiveCatPos === 1 && (shouldExpand) ? 0 + (isSub && !unlimitedScroll ? 35 : 0) : 0)}
        catPos={responsiveCatPos}
        theme={theme}
        cart={cart}
        menuList={mnList}
        removeFromCart={removeFromCart}
        headerHeight={responsiveHeaderHeight + mobileTakeawayOffset + (responsiveCatPos === 1 && shouldExpand ? (topCatType == 1 && !effectiveScrollDown ? 96 : 50) + (isSub && !unlimitedScroll ? 35 : 0) : 0)}
        sidebarWidth={responsiveCatPos === 1 ? 0 : responsiveSidebarWidth}
        menuSelectionFormRef={menuSelectionFormRef}
        selectedMenu={selectedMenu}
        selectedCategory={selectedCategory}
        addItemDirect={addItemDirect}
        unlimitedScroll={unlimitedScroll}
        lanIndex={lanIndex}
        isLanReverse={isLanReverse}
        setSelectedMenu={setSelectedMenu}
        setSelectedCategory={setSelectedCategory}
        isScrolling={isScrolling}
        lastPos={lastPos}
        setLastPos={setLastPos}
        addRecItemToCart={addRecItemToCart}
        onAddToCart={() => {
          setIsSearch(false);
          setSearchTxt("");
          setSearching(false);
          addNewItemToCart(menuSelectionFormRef.current);
        }}
        addToCartText={languageContext[lanIndex].addToCart}
        addRecentItem={addRecentItem}
        recentBought={recentBought}
        recentItem={recentItem}
        menuRecommendation={menuRecommendation}
        setScrollDown={setScrollDown}
        topCatType={topCatType}
        isScrollDown={effectiveScrollDown}
        mobileTakeawayOffset={mobileTakeawayOffset}
      />
      {showScrollTop && !selectedMenu &&
        <ScrollTopButton
          type="button"
          aria-label="Back to top"
          title="Back to top"
          themeContext={themeContext}
          bottomOffset={!isReadOnlyMenu && width < 768 ? 68 : 18}
          onClick={scrollMenuToTop}
        >
          <IoChevronUpOutline aria-hidden="true" />
          <span>TOP</span>
        </ScrollTopButton>
      }

    </MenuLayout>
  );
};

export default React.memo(Menu);

const MenuLayout = styled.div`
  display: flow-root;
  position: relative;
  width: 100%;
  max-width: ${DESKTOP_MENU_MAX_WIDTH}px;
  margin: 0 auto;
`;

const ScrollTopButton = styled.button`
  position: fixed;
  right: 16px;
  bottom: ${(props) => props.bottomOffset}px;
  z-index: 7;
  display: flex;
  width: 58px;
  height: 66px;
  padding: 7px 5px 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  border: 0;
  border-radius: 7px;
  background: ${(props) => props.themeContext.primaryColor || "#d60012"};
  color: ${props => actionTextColor(props.themeContext)};
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.24);
  font-family: ${(props) => props.themeContext.fontFamily};
  cursor: pointer;
  animation: scrollTopButtonIn 160ms ease-out;

  svg {
    width: 30px;
    height: 30px;
    stroke-width: 4;
  }

  span {
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
  }

  &:active {
    transform: translateY(1px);
  }

  @keyframes scrollTopButtonIn {
    from {
      transform: translateY(8px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (min-width: 768px) {
    right: max(24px, calc((100vw - ${DESKTOP_MENU_MAX_WIDTH}px) / 2 + 24px));
  }
`;

const CartButtonContainer = styled.div`
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  gap: 8px;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
  background: ${props => props.themeContext.backgroundColor};
  border-top: 1px solid ${props => props.themeContext.borderColor || "#eee"};
  @media (min-width: 768px) { display: none; }
`;
const BillButton = styled.button`
  display: flex;
  flex: 0 0 auto;
  height: 46px;
  padding: 0 14px;
  gap: 7px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => lightTint(props.themeContext.primaryColor, 0.25)};
  border-radius: 999px;
  background: transparent;
  color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)};
  font-family: ${props => props.themeContext.fontFamily};
  font-size: 12px;
  cursor: pointer;
`;
const CartText = styled.span`
  flex: 1;
  min-width: 0;
  text-align: left;
`;
const CartAmount = styled.span`
  flex-shrink: 0;
  white-space: nowrap;
`;
const CartButton = styled.button`
  display: flex;
  flex: 1;
  min-width: 0;
  height: 42px;
  padding: 0 16px;
  gap: 8px;
  align-items: center;
  border: 0;
  border-radius: 999px;
  background: ${props => props.themeContext.primaryColor};
  color: ${props => actionTextColor(props.themeContext)};
  font-family: ${props => props.themeContext.fontFamily};
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  > svg { flex-shrink: 0; }
  &:focus-visible { outline: 2px solid ${props => props.themeContext.primaryColor}; outline-offset: 2px; }
`;
